// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1__dc93d331bef057ce983d","cls2":"BulkFollowSuggestion-cls2___bd9343dac9f69a3ad8d BulkFollowSuggestion-cls1__dc93d331bef057ce983d"};